import { requiredParam, randomInt, maybeCall, verifyType } from '..';

export var repeater = function repeater(_ref) {
  var _ref$action = _ref.action,
      action = _ref$action === undefined ? requiredParam('action') : _ref$action,
      onClear = _ref.onClear,
      _ref$interval = _ref.interval,
      interval = _ref$interval === undefined ? 60 : _ref$interval,
      _ref$scale = _ref.scale,
      scale = _ref$scale === undefined ? 1000 : _ref$scale,
      _ref$jitter = _ref.jitter,
      jitter = _ref$jitter === undefined ? interval / 10 : _ref$jitter,
      _ref$autostart = _ref.autostart,
      autostart = _ref$autostart === undefined ? true : _ref$autostart,
      _ref$immediate = _ref.immediate,
      immediate = _ref$immediate === undefined ? true : _ref$immediate,
      _ref$name = _ref.name,
      name = _ref$name === undefined ? '' : _ref$name;


  var timer = undefined;

  verifyType(action, 'function');

  var clear = function clear() {
    maybeCall(onClear)();
    if (timer) {
      if (name) {
        console.log(name + ': clearing timer ' + timer);
      }
      clearInterval(timer);
      timer = undefined;
    }
  };

  var start = function start() {
    clear();
    if (immediate) perform();
    if (interval > 0) {
      timer = setInterval(perform, scale * (interval + (jitter ? randomInt({ min: -jitter, max: jitter }) : 0)));
      if (name) {
        console.log(name + ': created new timer ' + timer);
      }
    }
  };

  var perform = function perform() {
    if (name) {
      console.log(name + ' performs action()');
    }
    action();
  };

  if (autostart) start();

  return {
    clear: clear,
    start: start
  };
};